import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-device-peripheral',
  templateUrl: './device-peripheral.component.html',
  styleUrls: ['./device-peripheral.component.scss']
})
export class DevicePeripheralComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
